export default __webpack_public_path__ + "static/01_govern-d48179ebf26ede3a5d264bbd91a1c217.webm";